(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everwith-buying-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-ew-buying-guide]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const checks = Array.from(root.querySelectorAll('.checklist input[type="checkbox"]'));
      const status = root.querySelector('.status');
      if (!status) return;
      const template = status.dataset.progressTemplate;
      const update = () => {
        status.textContent = template.replace(/__COUNT__/g, String(checks.filter((check) => check.checked).length)).replace(/__TOTAL__/g, String(checks.length));
      };
      checks.forEach((check) => check.addEventListener('change', update));
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
